import React from "react";
import PropTypes from "prop-types";

import { getVisiblePageNumbers } from "shared/utils/pagination";
import IconButton from "../IconButton/IconButton";

import styles from "./Pagination.module.scss";

const Pagination = ({
  currentPage,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
  disabled = false,
  itemLabel = "items",
}) => {
  const rangeStart =
    totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const rangeEnd = Math.min(currentPage * pageSize, totalCount);
  const visiblePages = getVisiblePageNumbers(currentPage, totalPages);

  const handlePreviousPage = () => {
    onPageChange(currentPage - 1);
  };

  const handleNextPage = () => {
    onPageChange(currentPage + 1);
  };

  return (
    <div className={styles.pagination}>
      <span className={styles.summary}>
        {totalCount === 0
          ? `No ${itemLabel} to display`
          : `Showing ${rangeStart} to ${rangeEnd} of ${totalCount} ${itemLabel}`}
      </span>
      <div className={styles.controls}>
        <IconButton
          iconName="chevronLeft"
          ariaLabel="Previous page"
          disabled={currentPage === 1 || disabled}
          onClick={handlePreviousPage}
          className={styles.navButton}
        />

        <div className={styles.pageNumbers}>
          {visiblePages.map((page, index) =>
            page === "ellipsis" ? (
              <span
                key={`ellipsis-${index}`}
                className={styles.ellipsis}
                aria-hidden="true"
              >
                ...
              </span>
            ) : (
              <button
                key={page}
                type="button"
                className={`${styles.pageButton} ${
                  page === currentPage ? styles.pageButtonActive : ""
                }`}
                onClick={() => onPageChange(page)}
                disabled={disabled}
                aria-label={`Page ${page}`}
                aria-current={page === currentPage ? "page" : undefined}
              >
                {page}
              </button>
            )
          )}
        </div>

        <IconButton
          iconName="chevronRight"
          ariaLabel="Next page"
          disabled={currentPage >= totalPages || disabled}
          onClick={handleNextPage}
          className={styles.navButton}
        />
      </div>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  itemLabel: PropTypes.string,
};

export default Pagination;
